export default "__VITE_ASSET__C$_34TBQ__"